export default "__VITE_ASSET__CxItOVpb__"